import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../../Helper/BaseUrl";
import { toastErrorr, toastSuccesss } from "../../../Helper/ToastMessage";


// Get Table Data
export const WaterQuantityTableDataAPI = createAsyncThunk("WaterQuantityTableData", async ({ data }) => {
    const {
        M_TTP_LocationID,
        M_Distri_WS_LocationID,
        M_ProjectID,
        ReadingDate,
        token,
        M_WS_JunctionID,
        M_WardID,
        M_UserID,
        DashProjectTypeId,
        RoleID,
        Flag,
        handleWaterQuantityExport
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    let url

    if (DashProjectTypeId == '6' && RoleID != '16') {
        url = `${BaseUrl}/APKDashboard/Get_WEB_WS_T_Distri_WS_WaterQuantitySelect?M_ProjectID=${M_ProjectID ? M_ProjectID : '0'}&M_WardID=${M_WardID ? M_WardID : '0'}&M_Distri_WS_LocationID=${M_WS_JunctionID ? M_WS_JunctionID : '0'}&ReadingDate=${ReadingDate}&M_UserID=${M_UserID}`
    } else if (DashProjectTypeId == '9') {
        url = `${BaseUrl}/APKDashboard/Get_WEB_T_TTP_WaterQualitySelect?M_WardID=${M_WardID ? M_WardID : '0'}&M_UserID=${M_UserID}&M_ProjectID=${M_ProjectID ?? 0}&M_TTP_LocationID=${M_TTP_LocationID ? M_TTP_LocationID : '0'}&ReadingDate=${ReadingDate}`
    } else {
        url = `${BaseUrl}/APKDashboard/Get_WEB_WS_T_WS_WaterMainLineQuantitySelect?M_ProjectID=${M_ProjectID ? M_ProjectID : '0'}&M_WardID=${M_WardID ? M_WardID : '0'}&M_WS_JunctionID=${M_WS_JunctionID ? M_WS_JunctionID : '0'}&ReadingDate=${ReadingDate}&M_UserID=${M_UserID}&Flag=${Flag}`
    }

    return fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleWaterQuantityExport && handleWaterQuantityExport()
                return result.data
            } else {
                return result
            }
        })
})

const WaterQuantityTableDataSlice = createSlice({
    name: "WaterQuantityTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WaterQuantityTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(WaterQuantityTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(WaterQuantityTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const WaterQuantityTableDataReducer = WaterQuantityTableDataSlice.reducer


export const WaterQuantityTableExportDataAPI = createAsyncThunk("WaterQuantityTableExportData", async ({ data }) => {
    const {
        M_Distri_WS_LocationID,
        M_ProjectID,
        ReadingDate,
        token,
        M_WS_JunctionID,
        M_WardID,
        M_UserID,
        DashProjectTypeId,
        RoleID,
        Flag
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    let url

    if (DashProjectTypeId == '6' && RoleID != '16') {
        url = `${BaseUrl}/APKDashboard/Get_WEB_WS_T_Distri_WS_WaterQuantitySelect?M_ProjectID=${M_ProjectID ? M_ProjectID : '0'}&M_WardID=${M_WardID ? M_WardID : '0'}&M_Distri_WS_LocationID=${M_WS_JunctionID ? M_WS_JunctionID : '0'}&ReadingDate=${ReadingDate}&M_UserID=${M_UserID}`
    } else {
        url = `${BaseUrl}/APKDashboard/Get_WEB_WS_T_WS_WaterMainLineQuantitySelect?M_ProjectID=${M_ProjectID ? M_ProjectID : '0'}&M_WardID=${M_WardID ? M_WardID : '0'}&M_WS_JunctionID=${M_WS_JunctionID ? M_WS_JunctionID : '0'}&ReadingDate=${ReadingDate}&M_UserID=${M_UserID}&Flag=${Flag}`
    }

    return fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const WaterQuantityTableExportDataSlice = createSlice({
    name: "WaterQuantityTableExportData",
    initialState: {
        isExportLoading: false,
        ExportTableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WaterQuantityTableExportDataAPI.pending, (state, action) => {
            state.isExportLoading = true;
        });
        builder.addCase(WaterQuantityTableExportDataAPI.fulfilled, (state, action) => {
            state.isExportLoading = false;
            state.ExportTableData = action.payload;
        });
        builder.addCase(WaterQuantityTableExportDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isExportLoading = false;
            state.isError = true;
            state.ExportTableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const WaterQuantityTableExportDataReducer = WaterQuantityTableExportDataSlice.reducer


// InsertUpdate Table Data

export const WaterQuantityPostDataAPI = createAsyncThunk("WaterQuantityPostData", async ({ data }) => {
    const {
        T_TTP_WaterQualityID,
        T_WS_WaterMainLineQuantityID,
        T_Distri_WS_WaterQuantityID,
        IncomingFinalReading,
        OutgoingFinalReading,
        TodaysReading,
        M_UserID,
        token,
        handleIsPost,
        handleClearField,
        handleOnCloseClick,
        DashProjectTypeId,
        RoleID
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    if (DashProjectTypeId == '9') {
        formdata.append("T_TTP_WaterQualityID", T_TTP_WaterQualityID);
        formdata.append("IncomingFinalReading", IncomingFinalReading);
        formdata.append("OutgoingFinalReading", OutgoingFinalReading);
    }
    if (DashProjectTypeId == '6' && RoleID != '16') {
        formdata.append("T_Distri_WS_WaterQuantityID", T_Distri_WS_WaterQuantityID);
        formdata.append("IncomingFinalReading", IncomingFinalReading);
        formdata.append("OutgoingFinalReading", OutgoingFinalReading);
    } else {
        formdata.append("T_WS_WaterMainLineQuantityID", T_WS_WaterMainLineQuantityID);
        formdata.append("TodaysReading", TodaysReading);
    }
    formdata.append("M_UserID", M_UserID);


    var requestOptions = {
        method: 'PATCH',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    let url
    if (DashProjectTypeId == '6' && RoleID != '16') {
        url = `${BaseUrl}/APKDashboard/Post_WEB_WS_T_Distri_WS_WaterQuantity_Update`
    }else if (DashProjectTypeId == '9') {
        url = `${BaseUrl}/APKDashboard/Post_WEB_T_TTP_WaterQuality_Update`
    }else {
        url = `${BaseUrl}/APKDashboard/Post_WEB_WS_T_WS_WaterMainLineQuantity_Update`
    }

    fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleIsPost()
                // handleClearField()
                handleOnCloseClick()
                toastSuccesss(result.message)
                return result.data
            } else {
                handleOnCloseClick()
                toastErrorr(result.message)
            }

            return result
        })
})

const WaterQuantityPostDataSlice = createSlice({
    name: "WaterQuantityPostData",
    initialState: {
        isPostLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WaterQuantityPostDataAPI.pending, (state, action) => {
            state.isPostLoading = true;
        });
        builder.addCase(WaterQuantityPostDataAPI.fulfilled, (state, action) => {
            state.isPostLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(WaterQuantityPostDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isPostLoading = false;
            state.isError = true;
            state.tableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const WaterQuantityPostDataReducer = WaterQuantityPostDataSlice.reducer



// // Delete Table Data

export const WaterQuantityDeleteAPI = createAsyncThunk("WaterQuantityDelete", async ({ data }) => {

    const {
        T_TTP_WaterQualityID,
        T_Distri_WS_WaterQuantityID,
        T_WS_WaterMainLineQuantityID,
        M_UserID,
        handleIsPost,
        token,
        DashProjectTypeId,
        RoleID
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();

    if (DashProjectTypeId == '6' && RoleID != '16') {
        formdata.append("T_Distri_WS_WaterQuantityID", T_Distri_WS_WaterQuantityID);
    } else if (DashProjectTypeId == '9') {
        formdata.append("T_TTP_WaterQualityID", T_TTP_WaterQualityID);
    } else {
        formdata.append("T_WS_WaterMainLineQuantityID", T_WS_WaterMainLineQuantityID);
    }
    formdata.append("M_UserID", M_UserID);

    var requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    let url
    if (DashProjectTypeId == '6' && RoleID != '16') {
        url = `${BaseUrl}/APKDashboard/WEB_WS_T_Distri_WS_WaterQuantity_Delete`
    } else if (DashProjectTypeId == '9') {
        url = `${BaseUrl}/APKDashboard/WEB_T_TTP_WaterQuality_Delete`
    } else {
        url = `${BaseUrl}/APKDashboard/WEB_WS_T_WS_WaterMainLineQuantity_Delete`
    }

    fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.status) {
                handleIsPost()
                // handleDeleteCloseClick()
                toastSuccesss(result.message)
            } else {
                toastErrorr(result.message)
                // handleDeleteCloseClick()
            }
            return result

        })
})

const WaterQuantityDeleteSlice = createSlice({
    name: "WaterQuantityDelete",
    initialState: {
        isDeleteLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WaterQuantityDeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(WaterQuantityDeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.tableData = action.payload;
            // toastSuccesss(action.payload.message)
        });
        builder.addCase(WaterQuantityDeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const WaterQuantityDeleteReducer = WaterQuantityDeleteSlice.reducer